import { render } from "./VoteButtons.vue?vue&type=template&id=6d1a5794&scoped=true"
import script from "./VoteButtons.vue?vue&type=script&lang=js"
export * from "./VoteButtons.vue?vue&type=script&lang=js"

import "./VoteButtons.vue?vue&type=style&index=0&id=6d1a5794&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1a5794"]])

export default __exports__